import { useInstance, onMounted } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
import { isObject } from 'intact-shared';
export function useAutoRows(inputRef) {
  var instance = useInstance();
  var height = useState(0);
  var lineHeight;
  var paddingTop;
  var paddingBottom;
  var isBorderBox;
  function getStyles() {
    if (instance.get('type') === 'textarea') {
      var styles = getComputedStyle(inputRef.value);
      lineHeight = parseInt(styles.lineHeight);
      paddingTop = parseInt(styles.paddingTop);
      paddingBottom = parseInt(styles.paddingBottom);
      isBorderBox = styles.boxSizing === 'border-box';
    }
  }
  onMounted(getStyles);
  instance.watch('type', getStyles, {
    presented: true
  });
  instance.watch('value', adjust, {
    inited: true,
    presented: true
  });
  instance.watch('placeholder', adjust, {
    inited: true,
    presented: true
  });
  instance.watch('rows', adjust, {
    inited: true,
    presented: true
  });
  onMounted(adjust);
  function adjust() {
    var _instance$get = instance.get(),
      rows = _instance$get.rows,
      type = _instance$get.type;
    if (type === 'textarea' && (rows === 'auto' || isObject(rows))) {
      var textarea = inputRef.value;
      var originheight = textarea.style.height;
      // we shuold remove height before get scrollHeight,
      // otherwise we cannot shrink the height when we remove the text
      textarea.style.height = '';
      var scrollHeight = textarea.scrollHeight;
      var lines = (scrollHeight - paddingTop - paddingBottom) / lineHeight;
      textarea.style.height = originheight;
      var actualLines = lines;
      if (rows !== 'auto') {
        var min = rows.min,
          max = rows.max;
        if (min && lines <= min) {
          actualLines = min;
        }
        if (max && lines >= max) {
          actualLines = max;
        }
      }
      height.set(lineHeight * actualLines + (isBorderBox ? paddingTop + paddingBottom + 2 /* border */ : 0));
      return;
    }
    height.set(0);
  }
  return height;
}